export class MatchClock {
  private decisionAccumulator = 0;
  private snapshotAccumulator = 0;

  constructor(
    readonly durationSeconds: number,
    readonly decisionIntervalSeconds: number,
    readonly snapshotIntervalSeconds: number,
  ) {}

  advance(deltaTime: number): void {
    this.decisionAccumulator += deltaTime;
    this.snapshotAccumulator += deltaTime;
  }

  consumeDecision(): boolean {
    if (this.decisionAccumulator + 1e-9 < this.decisionIntervalSeconds) return false;
    this.decisionAccumulator -= this.decisionIntervalSeconds;
    return true;
  }

  consumeSnapshot(): boolean {
    if (this.snapshotAccumulator + 1e-9 < this.snapshotIntervalSeconds) return false;
    this.snapshotAccumulator -= this.snapshotIntervalSeconds;
    return true;
  }
}

